import { render, staticRenderFns } from "./perfectMoney.vue?vue&type=template&id=4f4b1076&"
import script from "./perfectMoney.vue?vue&type=script&lang=js&"
export * from "./perfectMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports